import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { type FC } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import { AnnotationForm } from '~/components/common/AnnotationForm'
import { localStoragePersister as persister, queryClient } from '~/services/queryClient'
import { NextUIProvider } from '@nextui-org/react'

export const Page: FC = () => {
  return (
    <div className='w-screen h-screen overflow-auto flex justify-center items-center'>
      <AnnotationForm />
      <Toaster containerStyle={{ zIndex: 99999 }} />
    </div>
  )
}

export default Page
